import MondayIntegrationsConnectionsComponent from "./monday-integrations-connections-component";
import MondayIntegrationsConnectionsConfig from "./monday-integrations-connections-config";
import MondayIntegrationsConnectionsAdvancedConfig from "./monday-integrations-connections-advanced-config";

export default {
  MondayIntegrationsConnectionsComponent,
  MondayIntegrationsConnectionsConfig,
  MondayIntegrationsConnectionsAdvancedConfig
};
